import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../service/api.service';
import { AuthenticationService } from '../../service/authentication.service';
import { UtilService } from '../../service/util.service';
import { Constants } from '../../constants/constants';
import { ToastService } from '../../service/toast.service';
import { NgForm } from '@angular/forms';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss']
})
export class CustomersComponent implements OnInit {

  customers: any;
  customerFormData: any = {};
  driverFormData: any = {};
  selectedAdmins: Array<string> = new Array();
  selectedAdminsCount = 0;
  deletedAdminsCount = 0;
  deleteAdminsFailed: Array<string> = new Array();
  accountCategory: string;
  loggedInUserId: any;
  isAddDriver: false;
  ownerId: string;
  @ViewChild('addCustomerForm', { static: true }) public addCustomerForm: NgForm;
  @ViewChild('addDriverForm', { static: true }) public addDriverForm: NgForm;
  userRoles: any = [];
  vin: any;
  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService) { }

  ngOnInit() {
    this.accountCategory = this.apiService.accountDetail.category;
    // this.customers = this.customerRolesData.getAdminRoles();
    this.getAllCustomers();
    // this.getAccountUserRoles();
    this.loggedInUserId = this.authService.loggedInUser.userId;
    this.initDriverFormData();
  }

  getAllCustomers() {

    this.utilService.showSpinner();
    this.apiService.getAccountCustomers().then((data) => {
      this.utilService.hideSpinner();
      this.customers = data;
      console.log("customer data ::", data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getAllCustomers();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  addCustomer(requestPayload) {
    console.log("Adding customer with data : ", requestPayload);
    this.utilService.showSpinner();
    this.apiService.addCustomers(requestPayload).then((data) => {
      this.utilService.hideSpinner();
      this.ownerId = data.userId;
      this.toast.showSuccess("Customer Added successfully");
      document.getElementById("closeAddCustomer").click();
      this.resetAddCustomerForm();
      //this.getAllCustomers();
      console.log("add customer response ::", data);
      this.initDriverFormData();
      document.getElementById('addDriverButton').click();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.addCustomer(requestPayload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  createCustomerPayload() {
    const requestPayload = {
      "role": "ROLE_B2C_OWNER",
      "name": this.customerFormData.name,
      "username": this.customerFormData.customerEmail,
      "phone": this.customerFormData.customerPhone,
      "vin": this.customerFormData.vin,
      "dealerId": this.apiService.accountDetail.id
      //"image": this.customerFormData.image
    };
    this.vin = this.customerFormData.vin;
    return requestPayload;
  }

  addDrivers(requestPayload) {
    console.log("Adding driver with data : ", requestPayload);
    this.utilService.showSpinner();
    this.apiService.addDrivers(requestPayload, this.vin).then((data) => {
      this.utilService.hideSpinner();
      this.toast.showSuccess("Family member added successfully");
      document.getElementById("closeAddDriver").click();
      this.resetAddDriverForm();
      console.log("add driver response ::", data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.addDrivers(requestPayload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  createDriversPayload() {
    const requestPayload = {
      "role": "ROLE_B2C_DRIVER",
      "name": this.driverFormData.name,
      "username": this.driverFormData.driverEmail,
      "phone": this.driverFormData.driverPhone,
      "ownerRelations": this.driverFormData.relationship,
      "isMinor": this.driverFormData.isMinor,
      "dealerId": this.apiService.accountDetail.id,
      "ownerId": this.ownerId
      //"image": this.driverFormData.image
    };
    return requestPayload;
  }

  onCustomerSelected(id: string) {
    console.log("customer id::", id);
    let itemIndex = this.selectedAdmins.indexOf(id);
    if (itemIndex !== -1) {
      this.selectedAdmins.splice(itemIndex, 1);
    } else {
      this.selectedAdmins.push(id);
    }
    console.log("selected customers::", this.selectedAdmins);
  }

  onDeleteAdmins() {
    console.log("Received the request for delet customers::", this.selectedAdmins);
    if (this.selectedAdmins.length > 0) {
      this.selectedAdminsCount = this.selectedAdmins.length;
      this.selectedAdmins.forEach(userId => {
        this.deleteUser(userId);
      });
    } else {
      this.toast.showWarning("No user selected");
    }
  }

  relationChanged(data) {
    console.log("relation selected :", data);
  }

  onAddCustomer(form: NgForm) {
    console.log("customer form data::", this.customerFormData);
    if (form.valid) {
      var customerPayload = this.createCustomerPayload();
      console.log("customer paylaod : ", customerPayload);
      this.addCustomer(customerPayload);
    }

  }

  onAddDriver(form: NgForm) {
    console.log("driver form data::", this.driverFormData);
    if (form.valid) {
      if (isNullOrUndefined(this.driverFormData.relationship)) {
        this.toast.showWarning("Please select relationship");
        return;
      }
      var driverPayload = this.createDriversPayload();
      console.log("driver paylaod : ", driverPayload);
      this.addDrivers(driverPayload);
    }
  }

  initDriverFormData() {
    this.driverFormData = {
      "isMinor": false
    }
  }

  changeuploadFleetB2BLogoClicked() {
    document.getElementById("uploadUserLogoInput").click();
  }

  uploadFleetB2BLogo(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('file', file, file.name);
      formData.append('folder', 'user/' + this.apiService.accountDetail.id);

      this.utilService.showSpinner();
      this.apiService.uploadFleetLogo(formData).then((data) => {
        this.utilService.hideSpinner();
        console.log("Response is :: ", data);
        this.customerFormData['image'] = data.imageUrl;
      }).catch((error) => {
        console.log("err : ", error);
        if (error.status == Constants.HTTP_UNAUTHORISED) {
          this.authService.refreshToken().then(() => {
            this.utilService.hideSpinner();
            console.log("refresh token api executed");
            this.uploadFleetB2BLogo(event);
          });
        }
        else {
          this.utilService.hideSpinner();
          if (error && error.error && error.error.message) this.toast.showError(error.error.message);
          else this.toast.showError(Constants.UNKNOWN_ERROR);
        }
      });
    }
  }

  navigateToDetailPage(customer) {
    console.log("Selected customer : ", customer);
    this.utilService.selectedAccountUser = customer;
  }

  resetAddCustomerForm() {
    this.addCustomerForm.resetForm();
    this.addCustomerForm.reset();
    this.customerFormData = {};
  }

  resetAddDriverForm() {
    this.addDriverForm.resetForm();
    this.addDriverForm.reset();
    this.initDriverFormData();
    this.getAllCustomers();
  }

  getAccountUserRoles() {
    var requestPayload = {
      "type": "B2B"
    };
    this.utilService.showSpinner();
    this.apiService.getRoles(requestPayload).then((data) => {
      this.utilService.hideSpinner();
      console.log("User roles ::", data);
      this.userRoles = data;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getAccountUserRoles();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  deleteUser(userId) {
    this.utilService.showSpinner();
    this.apiService.deleteAccountUser(userId).then((data) => {
      this.utilService.hideSpinner();
      this.deletedAdminsCount += 1;
      this.resetAdminsDeleted();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.deleteUser(userId);
        });
      }
      else {
        this.utilService.hideSpinner();
        this.deleteAdminsFailed.push(userId);
        this.resetAdminsDeleted();
        // if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        // else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  resetAdminsDeleted() {
    if (this.selectedAdminsCount == (this.deletedAdminsCount + this.deleteAdminsFailed.length)) {

      if (this.deleteAdminsFailed.length == 0) {
        this.toast.showSuccess("Users Deleted successfully");
      } else {
        this.toast.showError("Delete failed for users : " + this.deleteAdminsFailed.length);
      }
      this.getAllCustomers();
      this.resetDeleteUser();
    }
  }


  resetDeleteUser() {
    this.selectedAdmins = [];
    this.selectedAdminsCount = 0;
    this.deletedAdminsCount = 0;
    this.deleteAdminsFailed = [];
  }

  cancelDeleteUser() {
    this.resetDeleteUser();
    this.resetCheckbox();
  }

  resetCheckbox() {
    var items = document.getElementsByName('checkbox');
    for (var i = 0; i < items.length; i++) {
      if (items[i]["type"] == 'checkbox')
        items[i]["checked"] = false;
    }
  }

}

